import PropTypes from "prop-types";
import Image from "next/image";

import { Grid, Box, Typography } from "@/components/core";
import { COUNTRY_CODE_TO_FLAG_PATH } from "@/utils/constants/common";

export function SelectOptions({ country, ...params }: any) {
  return (
    <Box {...params}>
      <Grid direction="row" justifyContent="space-between">
        <Grid.Item>
          <Grid spacing={1}>
            <Grid.Item>
              <Image
                alt={country.label}
                src={COUNTRY_CODE_TO_FLAG_PATH[country.isoCode]}
                width={40}
                loading="lazy"
              />
            </Grid.Item>
            <Grid.Item>
              <Typography>{country.label}</Typography>
            </Grid.Item>
          </Grid>
        </Grid.Item>
      </Grid>
    </Box>
  );
}

SelectOptions.propTypes = {
  country: PropTypes.shape({
    isoCode: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};
